import { CORE_PLUGIN } from "@/core"
import type { Plugin } from "@/plugins"
import { injectOptional } from "@/tsyringe-extend"
import { defineStore } from "pinia"
import { injectable, instanceCachingFactory, registry, singleton } from "tsyringe"
import type { App } from "vue"
import CustomerService from './components/CustomerService.vue'

export interface CustomerOption {
  // 关闭客服侧边栏功能
  disabled?: boolean
}

export const CustomerPluginOptionsInjectKey = 'CustomerPluginOptionsInjectKey'

export const useCustomerStore = defineStore('CustomerStore', {
  state: () => ({
  } as CustomerOption)
},)

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<CustomerOption, unknown>>((c) =>
      c.resolve(CustomerPlugin)
    ),
  },
])
@injectable()
export class CustomerPlugin implements Plugin<CustomerOption, unknown> {
  id: string | symbol = ''
  options: CustomerOption
  service: unknown
  constructor(@injectOptional(CustomerPluginOptionsInjectKey)
  options?: CustomerOption) {
    const store = useCustomerStore()
    this.options = store.$state
    if (options) {
      store.$patch(options)
    }
  }

  init(app: App<Element>): void {
    //
    app.component('IotaDefaultCustomer', CustomerService)
  }

  initialized(): void {
    //
  }
}
